import { memo, useMemo } from "react";

/**
 * About: ホテル名見出し + キャッチコピー
 *
 * ゲスト側 app/frontend/guest/plain/src/pages/[lang]/index.astro の
 * plain-top-hotel-name / plain-top-hotel-catch-copy utility 相当を再現。
 * - ホテル名: 24px (mobile) / 32px (tablet) / 40px (laptop)
 * - キャッチコピー: 14px (mobile) / 18px (tablet)
 */

type Props = {
	isShowHotelName: boolean;
	isShowHotelCatchCopy: boolean;
	hotelName?: string | null;
	hotelCatchCopy?: string | null;
	fontFamilyClassName: string;
	fontColor: string;
};

export const About = memo(
	({ isShowHotelName, isShowHotelCatchCopy, hotelName, hotelCatchCopy, fontFamilyClassName, fontColor }: Props) => {
		const canShowHotelName = useMemo(() => isShowHotelName && !!hotelName, [hotelName, isShowHotelName]);
		const canShowHotelCatchCopy = useMemo(
			() => isShowHotelCatchCopy && !!hotelCatchCopy,
			[hotelCatchCopy, isShowHotelCatchCopy],
		);

		return (
			<div className="text-center" style={{ fontFamily: fontFamilyClassName, color: fontColor }}>
				{canShowHotelName && (
					<h1 className="text-2xl font-bold tablet:text-3xl laptop:text-4xl">{hotelName}</h1>
				)}
				{canShowHotelCatchCopy && (
					<p className="pt-1 text-sm font-medium tablet:pt-2 tablet:text-lg">{hotelCatchCopy}</p>
				)}
			</div>
		);
	},
);
